import DynamicBreadcrumbs from "@/components/DynamicBreadcrumbs";
import useBreadcrumbLinks from "@/reports/teacher/utils/useBreadcrumbsLinks";
import { breadcrumbsCss } from "./InsightsBreadcrumb.style";

export interface BreadcrumbLink {
  contents: string;
  href?: string;
}
export interface InsightsBreadcrumbProps {
  breadcrumbsLinks: BreadcrumbLink[];
}

const InsightsBreadcrumb = ({ breadcrumbsLinks }: InsightsBreadcrumbProps) => {
  const links = useBreadcrumbLinks([], breadcrumbsLinks);

  return (
    <DynamicBreadcrumbs
      breadcrumbsCss={breadcrumbsCss}
      breadcrumbsLinks={links}
    />
  );
};

export default InsightsBreadcrumb;
